export enum ComputeVariant {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  COMMON = 'COMMON',
  MAIN = 'MAIN',
}
